import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { paragraphRecipe } from './styles/paragraph.styles';
import type { ParagraphPropsInterface } from './types/paragraph.types';

/**
 * @since 6.0.0
 */

export const Paragraph = forwardRef<HTMLParagraphElement, ParagraphPropsInterface>(
  (props: ParagraphPropsInterface, forwardedRef) => {
    const { className, css: cssProp, color = 'text.neutral', textStyle = 'body', ...rest } = props;

    const styles = css(paragraphRecipe.raw({ color, textStyle }), cssProp);

    return (
      <p
        ref={forwardedRef}
        data-c11n-component="Paragraph"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', 'c11n_paragraph', 'c11n-semantic', styles, className)}
        {...rest}
      />
    );
  },
);

Paragraph.displayName = 'Paragraph';
